module.exports = __webpack_public_path__ + "static/media/male.3c975d5b.svg";